export const activity = {
  activityWebEmptyStateTitle: 'Zatím žádná aktivita',
  activityWebEmptyStateText: 'Zde bude váš seznam oznámení',
  activitySeeAll: 'Zobrazit vše',
  in: 'v'
}
